//import useToken from './useToken';



export class BetService {

    getPartidosList(token1) {
        //var respuesta = fetch('http://192.168.1.27/public/laraveldocker/public/api/bets', {
        var respuesta = fetch(process.env.REACT_APP_URL+'bets', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer '+token1
            },
            //body: JSON.stringify(credentials)
        })
        .then(data => data.json());
        return respuesta;
	}

    getPartidosUser(token1, id) {
        //console.log(id+"uno");
        //var respuesta = fetch('http://192.168.1.27/public/laraveldocker/public/api/bets', {
        var respuesta = fetch(process.env.REACT_APP_URL+'bets/'+id, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer '+token1
            },
            //body: JSON.stringify(credentials)
        })
        .then(data => data.json());
        return respuesta;
	}


    newMatch(teamData, token) {    
        //var respuesta = fetch('http://192.168.1.27/public/laraveldocker/public/api/bets', {
        var respuesta = fetch(process.env.REACT_APP_URL+'bets', {
            method: 'POST',
            // mode: 'cors',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer '+token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(teamData)
        })
        .then(data => data.json());
        //console.log (respuesta);
        return respuesta;
    }

    getPuntajeTotal(token, id) {    
        //var respuesta = fetch('http://192.168.1.27/public/laraveldocker/public/api/puntajetotal', {
        var respuesta = fetch(process.env.REACT_APP_URL+'puntajetotal', {
            method: 'POST',
            // mode: 'cors',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer '+token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ visit: id })
        })
        .then(data => data.json());
        return respuesta;
    }

}   
